class ME_CheckDownload {
 constructor() {
  this.checkUrlDownload();
 }

 checkUrlDownload() {
  let buttonDownload = document.querySelectorAll('.charts');
  if (buttonDownload.length < 0) {
   return
  }
  for (let i = 0; i < buttonDownload.length; i++) {
   buttonDownload[i].addEventListener('click', function () {
    let hrefD = buttonDownload[i].getAttribute('href');
    buttonDownload[i].innerHTML = '';
    buttonDownload[i].classList.add('loading');
    var startTime = new Date().getTime();

    fetch(`${hrefD}`)
     .then(response => {
      var endTime = new Date().getTime();
      var downloadTime = endTime - startTime;
      setTimeout(() => {
       buttonDownload[i].classList.remove('loading');
       buttonDownload[i].innerHTML = 'Raport został pobrany';
       buttonDownload[i].setAttribute('disabled', true);
       setTimeout(() => {
        buttonDownload[i].innerHTML = 'Pobierz raport w PDF';
        buttonDownload[i].removeAttribute('disabled');
       }, 3000);
      }, downloadTime);
      return response
     })
     .catch(error => {
      console.error('Wystąpił błąd:', error);
     });
   })
  }
 }
}


